import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.images');
import { OnInit, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-images',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.images/view.scss */
/* src/app/page.admin.images/view.scss: no such file or directory */`],
})
export class PageAdminImagesComponent implements OnInit {
    @ViewChild('logContainer') logContainer: ElementRef;
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public list: any = [];
    public keyuptime: any = 0;

    public search: any = {
        text: "",
        page: 1,
        dump: 40,
        type: ""
    };

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    };

    // Create modal
    public showCreateModal: boolean = false;
    public showMirrorModal: boolean = false;
    public createData: any = { namespace: '', type: 'build', harbor_project: 'base', description: '' };
    public mirrorData: any = { source_image: '', harbor_project: 'base', namespace: '' };
    public harborProjects: any[] = [];
    public creating: boolean = false;
    public mirroring: boolean = false;

    // Log modal
    public showLogModal: boolean = false;
    public logTitle: string = '';
    public logContent: string = '';
    public logRunning: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role("admin", "/");
        await this.loadHarborProjects();
        await this.load();
    }

    public async loadHarborProjects() {
        try {
            const { code, data } = await wiz.call("harbor_projects");
            if (code === 200) {
                this.harborProjects = data;
                await this.service.render();
            }
        } catch (e) { }
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", this.search);
        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public async searchAction() {
        let keyuptime: any = new Date().getTime();
        this.keyuptime = keyuptime;
        await this.service.render(500);
        if (this.keyuptime != keyuptime) return;
        await this.load();
    }

    public async filterType(type: string) {
        this.search.type = this.search.type === type ? "" : type;
        await this.load();
    }

    // Create build image
    public async openCreateModal() {
        this.createData = { namespace: '', type: 'build', harbor_project: 'base', description: '', version: '1.0.0' };
        this.showCreateModal = true;
        await this.service.render();
    }

    public async closeCreateModal() {
        this.showCreateModal = false;
        await this.service.render();
    }

    public async createImage() {
        if (this.creating) return;
        if (!this.createData.namespace) {
            await this.service.modal.error('Namespace is required');
            return;
        }
        if (!/^[a-z0-9][a-z0-9\-_]*$/.test(this.createData.namespace)) {
            await this.service.modal.error('Namespace: lowercase letters, numbers, hyphens, underscores only');
            return;
        }
        this.creating = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("create", { data: JSON.stringify(this.createData) });
            if (code === 200) {
                this.showCreateModal = false;
                this.service.href(`/admin/images/${data.id}`);
            } else {
                await this.service.modal.error(data.message || 'Failed to create');
            }
        } catch (e) {
            await this.service.modal.error('Failed to create image');
        }
        this.creating = false;
        await this.service.render();
    }

    // Mirror image
    public async openMirrorModal() {
        this.mirrorData = { source_image: '', harbor_project: 'base', namespace: '' };
        this.showMirrorModal = true;
        await this.service.render();
    }

    public async closeMirrorModal() {
        this.showMirrorModal = false;
        await this.service.render();
    }

    public async autoFillNamespace() {
        if (this.mirrorData.source_image && !this.mirrorData.namespace) {
            // Extract namespace from image URL: e.g. "mysql:latest" -> "mysql", "milvusdb/milvus:latest" -> "milvus"
            let src = this.mirrorData.source_image.split(':')[0];
            let parts = src.split('/');
            this.mirrorData.namespace = parts[parts.length - 1].replace(/[^a-z0-9\-_]/g, '');
            await this.service.render();
        }
    }

    public async mirrorImage() {
        if (this.mirroring) return;
        if (!this.mirrorData.source_image || !this.mirrorData.namespace) {
            await this.service.modal.error('Source image and namespace required');
            return;
        }
        this.mirroring = true;
        await this.service.render();

        // Create the image record first
        const createReq = {
            namespace: this.mirrorData.namespace,
            type: 'mirror',
            harbor_project: this.mirrorData.harbor_project,
            source_image: this.mirrorData.source_image,
            description: `Mirrored from ${this.mirrorData.source_image}`
        };
        const { code, data } = await wiz.call("create", { data: JSON.stringify(createReq) });
        if (code !== 200) {
            await this.service.modal.error(data.message || 'Failed to create');
            this.mirroring = false;
            await this.service.render();
            return;
        }

        // Close mirror modal and open log modal with SSE streaming
        this.showMirrorModal = false;
        const params = new URLSearchParams({
            id: data.id,
            source_image: this.mirrorData.source_image,
            harbor_project: this.mirrorData.harbor_project
        });
        await this.runSSE(`/wiz/api/page.admin.images/mirror_stream?${params}`, 'Mirror Image');
        this.mirroring = false;
        await this.load();
    }

    public async refreshMirror(item: any) {
        if (this.logRunning) return;
        const params = new URLSearchParams({ id: item.id });
        await this.runSSE(`/wiz/api/page.admin.images/mirror_refresh?${params}`, `Refresh: ${item.namespace}`);
        await this.load();
    }

    private async runSSE(url: string, title: string) {
        this.logTitle = title;
        this.logContent = '';
        this.logRunning = true;
        this.showLogModal = true;
        await this.service.render();

        try {
            const resp = await fetch(url);
            if (!resp.ok || !resp.body) {
                this.logContent += `\n❌ Request failed (${resp.status})\n`;
                this.logRunning = false;
                await this.service.render();
                return;
            }
            const reader = resp.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (!line.startsWith('data: ')) continue;
                    try {
                        const event = JSON.parse(line.substring(6));
                        if (event.type === 'step') {
                            this.logContent += `\n${event.message}\n`;
                        } else if (event.type === 'log') {
                            this.logContent += `  ${event.message}\n`;
                        } else if (event.type === 'done') {
                            this.logContent += `\n✅ ${event.message}\n`;
                        } else if (event.type === 'error') {
                            this.logContent += `\n❌ ${event.message}\n`;
                        }
                        await this.service.render();
                        this.scrollLogToBottom();
                    } catch (e) { }
                }
            }
            if (buffer.startsWith('data: ')) {
                try {
                    const event = JSON.parse(buffer.substring(6));
                    if (event.type === 'done') {
                        this.logContent += `\n✅ ${event.message}\n`;
                    } else if (event.type === 'error') {
                        this.logContent += `\n❌ ${event.message}\n`;
                    }
                    await this.service.render();
                    this.scrollLogToBottom();
                } catch (e) { }
            }
        } catch (e: any) {
            this.logContent += `\n❌ Connection error: ${e.message}\n`;
            await this.service.render();
        }
        this.logRunning = false;
        await this.service.render();
    }

    private scrollLogToBottom() {
        try {
            if (this.logContainer?.nativeElement) {
                const el = this.logContainer.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        } catch (e) { }
    }

    public async deleteImage(item: any) {
        let res = await this.service.modal.show({
            title: 'Delete Image',
            message: `Delete "${item.namespace}"?`,
            status: 'error',
            actionBtn: 'error',
            action: 'Delete',
            cancel: 'Cancel'
        });
        if (!res) return;
        this.loading = true;
        await this.service.render();
        await wiz.call("delete", { id: item.id });
        this.loading = false;
        await this.load();
    }

    public async closeLogModal() {
        if (this.logRunning) return;
        this.showLogModal = false;
        await this.service.render();
    }

    public statusColor(status: string) {
        const map: any = {
            'draft': 'bg-gray-100 text-gray-700',
            'building': 'bg-yellow-100 text-yellow-700',
            'pushing': 'bg-blue-100 text-blue-700',
            'ready': 'bg-green-100 text-green-700',
            'error': 'bg-red-100 text-red-700'
        };
        return map[status] || 'bg-gray-100 text-gray-700';
    }
}

export default PageAdminImagesComponent;